import {metadaApi} from '@dms/api/base';

import {
  AnnualMileageRequest,
  AnnualMileageResponse,
  GetHistoryOrderProfitabilityApiArg,
  GetHistoryOrderProfitabilityApiArgSchema,
  GetHistoryOrderProfitabilityApiResponse,
  GetHistoryOrderProfitabilityApiResponseSchema,
  GetServiceCaseByVehicleCountApiArg,
  GetServiceCaseByVehicleCountApiArgSchema,
  GetServiceCaseByVehicleCountApiResponse,
  GetServiceCaseByVehicleCountApiResponseSchema,
} from './types';

export const metadaWorkshopApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getHistoryOrderProfitability: build.query<
      GetHistoryOrderProfitabilityApiResponse,
      GetHistoryOrderProfitabilityApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/vehicle/${queryArg.vehicleId}/order-profitability`,
        queryArg,
      }),
      providesTags: ['profitabilityHistory'],
      extraOptions: {
        requestSchema: GetHistoryOrderProfitabilityApiResponseSchema,
        responseSchema: GetHistoryOrderProfitabilityApiArgSchema,
      },
    }),
    getServiceCaseByVehicleCount: build.query<
      GetServiceCaseByVehicleCountApiResponse,
      GetServiceCaseByVehicleCountApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/vehicle/${queryArg.vehicleId}/service-cases/count`,
        params: {status: queryArg.status},
        queryArg,
      }),
      providesTags: ['serviceCaseByVehicleCount'],
      extraOptions: {
        requestSchema: GetServiceCaseByVehicleCountApiArgSchema,
        responseSchema: GetServiceCaseByVehicleCountApiResponseSchema,
      },
    }),
    annualMileage: build.query<AnnualMileageResponse, AnnualMileageRequest>({
      query: (queryArg) => ({
        url: `/service/v1/vehicle/${queryArg.vehicleId}/annual-mileage`,
      }),
    }),
  }),
});

export const {
  useGetHistoryOrderProfitabilityQuery,
  useGetServiceCaseByVehicleCountQuery,
  useAnnualMileageQuery,
} = metadaWorkshopApi;
